export const useDetailPromotionPage = async () => {
  const nuxtApp = useNuxtApp()
  const eventButtonName = ref('')

  const {
    item: promotion,
    relatedItems: relatedPromotions,
    breadcrumb: breadcrumbItem,
  } = await usePageDetailApi<Product>({
    path: '/promotions/',
    previewPath: '/promotion-previews/',
  })

  // Update view count (once per session)
  if (import.meta.client && promotion.value?._id) {
    const viewKey = `viewed-promotion-${promotion.value._id}`
    if (!sessionStorage.getItem(viewKey)) {
      const { $api } = nuxtApp
      $api(`/promotions/${promotion.value.slug}/_view`, { method: 'PATCH' })
        .then(() => sessionStorage.setItem(viewKey, '1'))
        .catch(() => {})
    }
  }

  const showPriceRange = computed(() => {
    if (!promotion.value) { return false }
    return promotion.value.showPromotionOptions &&
      promotion.value.options.length !== 1 &&
      promotion.value.minPriceOfDiscountedOption !== null &&
      promotion.value.minPriceOfDiscountedOption !== 0 &&
      promotion.value.minPriceOption !== null &&
      promotion.value.minPriceOption !== 0 &&
      promotion.value.minPriceOption === promotion.value.minPriceOfDiscountedOption &&
      promotion.value.maxPriceOfDiscountedOption === promotion.value.maxPriceOption
  })

  const showDiscountedPriceRange = computed(() => {
    if (!promotion.value) { return false }
    return promotion.value.showPromotionOptions &&
      promotion.value.options.length !== 1 &&
      promotion.value.minPriceOfDiscountedOption !== null &&
      promotion.value.minPriceOfDiscountedOption !== 0 &&
      promotion.value.minPriceOption !== null &&
      promotion.value.minPriceOption !== 0
  })

  const categoryEventName = 'Promotion'
  const eventShareName = 'click_promotion_social_shared'
  const { analyticEvent, fbPixelEvent } = useAnalytic()
  const eventPromotionRelated = (title: string) => {
    analyticEvent(
      {
        ga4ActionName: 'click_promotion',
        ga4Label: title,
      })
    fbPixelEvent({
      fbCategory: 'trackCustom',
      fbEvent: categoryEventName,
      fbValue: { label: title },
    })
  }

  const { getPath, slugPageInfo, domain } = useNavigationMenu()

  useCustomSeo({
    title: () => promotion.value?.metaTitleFront,
    description: () => promotion.value?.metaDescriptionFront,
    image: () => promotion.value?.ogImage?.large || promotion.value?.imageCover?.large,
    keywords: () => promotion.value?.focusKeyword,
  })

  const { adaptIcon } = useIconV2Adapter()

  //  org schema
  const currencyStore = useCurrencyStore()
  const currencyName = computed(() => currencyStore.currentName)

  nuxtApp.runWithContext(() => useSchemaOrg([
    defineOffer({
      '@id': `${domain.value}/${promotion.value?.slug}#promotion`,
      '@type': 'CreativeWork',
      name: promotion.value?.title,
      description: promotion.value?.description,
      image: promotion.value?.ogImage?.large || promotion.value?.imageCover?.large || '',
      isPartOf: { '@id': `${domain.value}/#website` },
      brand: { '@id': `${domain.value}/#organization` },
      offers: promotion.value?.priceOfDiscounted && promotion.value?.priceOfDiscounted < promotion.value?.price
        ? {
            '@type': 'AggregateOffer',
            lowPrice: promotion.value?.priceOfDiscounted || 0,
            highPrice: promotion.value?.price || 0,
            priceCurrency: currencyName.value,
            availability: 'https://schema.org/InStock',
            url: `${domain.value}${getPath({ componentName: 'Promotion', slug: promotion.value?.slug })}`,
          }
        : {
            '@type': 'Offer',
            price: promotion.value?.price || 0,
            priceCurrency: currencyName.value,
            availability: 'https://schema.org/InStock',
            url: `${domain.value}${getPath({ componentName: 'Promotion', slug: promotion.value?.slug })}`,
          },
    }),
  ]))

  return {
    slugPageInfo,
    categoryEventName,
    eventButtonName,
    promotion: {
      ...promotion.value,
      callToActionIcon: adaptIcon(promotion.value?.callToActionIcon || ''),
    },
    relatedPromotions,
    breadcrumbItem,
    showPriceRange,
    showDiscountedPriceRange,
    getPath,
    eventPromotionRelated,
    eventShareName,
  }
}
